export default function Navbar() {
  return (
    <nav className="relative z-20 mx-auto flex w-full max-w-7xl items-center justify-between px-6 py-6 md:px-10 md:py-8">
      <a href="/" className="flex items-center gap-2 cursor-pointer">
        <span className="h-2.5 w-2.5 rounded-full bg-white" />
        <span
          className="text-[15px] tracking-tight text-white"
          style={{ fontFamily: "'Instrument Serif', serif", fontStyle: "italic" }}
        >
          paper
        </span>
      </a>

      <div className="hidden items-center gap-8 md:flex">
        <a
          href="#work"
          className="text-[13px] text-white/60 transition-colors hover:text-white cursor-pointer"
        >
          Work
        </a>
        <a
          href="#shaders"
          className="text-[13px] text-white/60 transition-colors hover:text-white cursor-pointer"
        >
          Shaders
        </a>
        <a
          href="#docs"
          className="text-[13px] text-white/60 transition-colors hover:text-white cursor-pointer"
        >
          Docs
        </a>
      </div>

      <a
        href="#start"
        className="rounded-full border border-white/15 bg-white/[0.04] px-4 py-2 text-[12px] font-medium text-white backdrop-blur-md transition-colors hover:bg-white/10 cursor-pointer whitespace-nowrap"
      >
        Sign in
      </a>
    </nav>
  );
}